// extracted by mini-css-extract-plugin
module.exports = {"login-background":"ResetPassword_login-background__1vEb7","card":"ResetPassword_card__1h3Ib"};